import { RouteRecordRaw } from 'vue-router'

import { brelagAdminRouteName, VIEW_ID } from '@/apps/brelag/brelag-admin/app'
import { clientAppRegistryGet } from '@/apps/clientAppRegistry'
import RouterPassThrough from '@/components/common/RouterPassThrough.vue'

import MainMenu from './components/MainMenu.vue'

const route: RouteRecordRaw = {
  path: clientAppRegistryGet(VIEW_ID, 'path'),
  name: VIEW_ID,
  redirect: { name: brelagAdminRouteName('mandator-list') },
  components: {
    default: RouterPassThrough,
    'main-menu': MainMenu,
  },
  children: [
    {
      path: 'mandator',
      name: brelagAdminRouteName('mandator-root'),
      redirect: { name: brelagAdminRouteName('mandator-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: 'list',
          name: brelagAdminRouteName('mandator-list'),
          props: true,
          component: () => import('./components/mandator/MandatorList.vue'),
          meta: {
            requiresList: {
              organisation: true,
            },
          },
        },
        {
          path: 'create',
          name: brelagAdminRouteName('organisation-create'),
          component: () => import('./components/mandator/MandatorForm.vue'),
          props: { id: '0' },
        },
        {
          path: ':id',
          name: brelagAdminRouteName('organisation-detail'),
          props: true,
          component: () => import('./components/mandator/MandatorForm.vue'),
        },
      ],
    },
    {
      path: 'admin',
      name: brelagAdminRouteName('admin-root'),
      redirect: { name: brelagAdminRouteName('admin-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: brelagAdminRouteName('profile-list'),
          redirect: {
            name: brelagAdminRouteName('admin-list'),
          },
        },
        {
          path: '',
          name: brelagAdminRouteName('admin-list'),
          props: true,
          component: () => import('./components/admin/MandatorAdminList.vue'),
        },
        {
          path: 'create',
          name: brelagAdminRouteName('admin-create'),
          component: () => import('./components/admin/MandatorAdminForm.vue'),
          props: { id: '0' },
        },
        {
          path: ':id',
          name: brelagAdminRouteName('profile-detail'),
          props: true,
          component: () => import('./components/admin/MandatorAdminForm.vue'),
        },
      ],
    },
    {
      path: 'supporter',
      name: brelagAdminRouteName('supporter-root'),
      redirect: { name: brelagAdminRouteName('supporter-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: brelagAdminRouteName('supporter-list'),
          props: true,
          component: () => import('./components/admin/SupporterList.vue'),
        },
        {
          path: 'create',
          name: brelagAdminRouteName('supporter-create'),
          component: () => import('./components/admin/SupporterForm.vue'),
          props: { id: '0' },
        },
        {
          path: ':id',
          name: brelagAdminRouteName('supporter-detail'),
          props: true,
          component: () => import('./components/admin/SupporterForm.vue'),
        },
      ],
    },
    {
      path: 'user',
      name: brelagAdminRouteName('user-root'),
      redirect: { name: brelagAdminRouteName('user-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: brelagAdminRouteName('user-list'),
          props: true,
          component: () => import('./components/admin/MandatorUserList.vue'),
        },
      ],
    },
    {
      path: 'offer',
      name: brelagAdminRouteName('offer-root'),
      redirect: { name: brelagAdminRouteName('offer-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: brelagAdminRouteName('offer-list'),
          props: true,
          component: () => import('./components/offer/OfferList.vue'),
          meta: {
            requiresList: {},
          },
        },
        {
          path: 'create',
          name: brelagAdminRouteName('offer-create'),
          component: () => import('./components/offer/OfferForm.vue'),
          props: { id: '0' },
        },
        {
          path: ':id',
          name: brelagAdminRouteName('offer-detail'),
          props: true,
          component: () => import('./components/offer/OfferForm.vue'),
        },
      ],
    },
    {
      path: 'album',
      name: brelagAdminRouteName('album-root'),
      redirect: { name: brelagAdminRouteName('album-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [],
    },
    {
      path: 'knockaut-module',
      name: brelagAdminRouteName('knockaut-module-root'),
      redirect: { name: brelagAdminRouteName('knockaut-module-list') },
      component: RouterPassThrough,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: brelagAdminRouteName('knockaut-module-list'),
          props: true,
          component: () =>
            import('./components/knockaut-module/KnockautModuleList.vue'),
          meta: {
            requiresList: {},
          },
        },
        {
          path: 'create',
          name: brelagAdminRouteName('knockaut-module-create'),
          component: () =>
            import('./components/knockaut-module/KnockautModuleForm.vue'),
          props: { id: '0' },
        },
        {
          path: ':id',
          name: brelagAdminRouteName('knockaut-module-detail'),
          props: true,
          component: () =>
            import('./components/knockaut-module/KnockautModuleForm.vue'),
        },
      ],
    },
  ],
}

export default route
